/* OVERLI — Calm Morning interactions
   - Thumbnail switcher
   - Bundle radio click handler (idempotent — works for app block bundles too)
   - Before / After clip-path slider (single CSS variable --pct)
   - Stats rings IntersectionObserver animation
   - Sticky mobile buy bar (appears only after scrolling PAST the bundle
     picker, hides near the final CTA)
   - Smooth-scroll for all secondary "order now" CTAs on the page
*/
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.ov-thumb').forEach(function (t) {
      if (t.dataset.ovBound === '1') return;
      t.dataset.ovBound = '1';
      t.addEventListener('click', function () {
        var gallery = t.closest('.ov-gallery') || document;
        gallery.querySelectorAll('.ov-thumb').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        var main = gallery.querySelector('.ov-main-img img');
        var src = t.getAttribute('data-src');
        if (main && src) main.setAttribute('src', src);
      });
    });

    document.querySelectorAll('.ov-bundle').forEach(function (b) {
      if (b.dataset.ovBound === '1') return;
      b.dataset.ovBound = '1';
      b.addEventListener('click', function () {
        var group = b.closest('.ov-bundles') || document;
        group.querySelectorAll('.ov-bundle').forEach(function (x) { x.classList.remove('selected'); });
        b.classList.add('selected');
      });
    });

    document.querySelectorAll('.ov-ba-wrap').forEach(function (wrap) {
      if (wrap.dataset.ovBound === '1') return;
      wrap.dataset.ovBound = '1';

      var dragging = false;

      function setPct(clientX) {
        var r = wrap.getBoundingClientRect();
        var p = ((clientX - r.left) / r.width) * 100;
        p = Math.max(0, Math.min(100, p));
        wrap.style.setProperty('--pct', p + '%');
      }
      function down(e) {
        dragging = true;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPct(x);
        if (e.cancelable) e.preventDefault();
      }
      function move(e) {
        if (!dragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPct(x);
      }
      function up() { dragging = false; }

      wrap.addEventListener('mousedown', down);
      wrap.addEventListener('touchstart', down, { passive: false });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('mouseup', up);
      window.addEventListener('touchend', up);
    });

    var rings = document.querySelectorAll('.ov-ring .ov-progress');
    if (rings.length && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var el = en.target;
            if (el.dataset.ovAnimated === '1') return;
            el.dataset.ovAnimated = '1';
            var pct = parseFloat(el.dataset.pct) || 0;
            var C = parseFloat(el.dataset.c) || 326.7;
            el.style.strokeDashoffset = (C * (1 - pct / 100)).toString();
            obs.unobserve(el);
          }
        });
      }, { threshold: 0.4 });
      rings.forEach(function (r) { obs.observe(r); });
    } else {
      rings.forEach(function (el) {
        var pct = parseFloat(el.dataset.pct) || 0;
        var C = parseFloat(el.dataset.c) || 326.7;
        el.style.strokeDashoffset = (C * (1 - pct / 100)).toString();
      });
    }

    initStickyBar();
  }

  function initStickyBar() {
    var bar = document.getElementById('ov-sticky-bar');
    if (!bar || bar.dataset.ovBound === '1') return;
    bar.dataset.ovBound = '1';

    // The bar appears ONLY after the visitor has scrolled PAST the bundle
    // picker (its bottom edge is above the viewport) — never before reaching
    // it — and hides again near the final CTA so it never covers it.
    var bundleArea = document.querySelector('.ov-bundles');
    var footerMarker = document.querySelector('.ov-final-cta');
    var passedBundles = false;
    var footerVisible = false;

    function update() {
      if (passedBundles && !footerVisible) {
        bar.classList.add('ov-visible');
      } else {
        bar.classList.remove('ov-visible');
      }
    }

    function checkPassed() {
      if (!bundleArea) { passedBundles = false; return; }
      passedBundles = bundleArea.getBoundingClientRect().bottom < 0;
    }

    if ('IntersectionObserver' in window && bundleArea) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        // Not intersecting AND its box sits above the viewport => passed it.
        passedBundles = !en.isIntersecting && en.boundingClientRect.bottom < 0;
        update();
      }, { threshold: 0 }).observe(bundleArea);

      if (footerMarker) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0 }).observe(footerMarker);
      }
    } else {
      window.addEventListener('scroll', function () { checkPassed(); update(); }, { passive: true });
      checkPassed();
      update();
    }

    function scrollToBundles(e) {
      if (!bundleArea) return;
      if (e && e.preventDefault) e.preventDefault();
      bundleArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    var ctaBtn = document.getElementById('ov-sticky-cta');
    if (ctaBtn) ctaBtn.addEventListener('click', scrollToBundles);

    // Make every other "order now" CTA on the page glide smoothly to the
    // bundle picker instead of jumping to the top (href="#" default).
    document.querySelectorAll('a.ov-cta, main a[href="#"], main a[href="#buy"], .copy-section a').forEach(function (a) {
      if (a.dataset.ovScrollBound === '1') return;
      a.dataset.ovScrollBound = '1';
      a.addEventListener('click', scrollToBundles);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
